import { render } from "./ItemPanelSearch.vue?vue&type=template&id=f0d980e4"
import script from "./ItemPanelSearch.vue?vue&type=script&lang=js"
export * from "./ItemPanelSearch.vue?vue&type=script&lang=js"

import "./ItemPanelSearch.vue?vue&type=style&index=0&id=f0d980e4&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__